import { useContext } from "react";
import { RaCreateView } from "../../components/views/RaCreateView";
import { Box, Typography } from "@mui/material";
import { Button, useTranslate } from "react-admin";
import { ProductForm } from "./ProductForm";
import { FileManagerContext } from "./FileManagerContext";

export const ProductListForm = () => {
    const translate = useTranslate();
    const { data, setData } = useContext(FileManagerContext);

    const addProduct = () => {
        setData((prev) => ({
            ...prev,
            productList: [
                ...(prev.productList || []),
                {
                    serialNumber: null,
                    manufacturer: "",
                    weight: null,
                    purchasePrice: null,
                    product: "",
                    isMassProduct: false,
                    sourceDescription: "",
                    sourceArticleNumber: "",
                },
            ],
        }));
    };

    const removeProduct = (index) => {
        const newProductArray = [...(data?.productList || [])];
        newProductArray.splice(index, 1);
        setData((prev) => ({
            ...prev,
            productList: newProductArray,
        }));
    };

    return (
        <RaCreateView mutationMode="pessimistic">
            <Box
                sx={{
                    minHeight: "calc(100vh - 135px)",
                    maxHeight: "calc(100vh - 135px)",
                    overflowY: "auto",
                    backgroundColor: "#1e1e1e",
                }}
            >
                <Typography variant="h6" sx={{ p: 2, mb: 2 }}>
                    {translate("equip.product_info")}
                </Typography>
                {data?.productList?.map((record, index) => (
                    <ProductForm
                        key={index}
                        removeProduct={removeProduct}
                        record={record}
                        index={index}
                    />
                ))}
                <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
                    <Button onClick={() => addProduct()}>
                        {translate("equip.extraction.addNewProduct")}
                    </Button>
                </Box>
            </Box>
        </RaCreateView>
    );
};
